import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

import {
    DropdownWrapper,
    DropdownInner,
    DropdownList,
    DropdownListItem,
    DropdownListItemInner,
} from './styled';


const DropdownMenu = ({menuItems, ...props}) => {
    const [direction, setDirection] = useState(props.direction);

    let wrapperRef = null;
    useEffect(() => {
        if (!wrapperRef) {
            return;
        }

        if (props.direction) {
            return;
        }

        const wrapper = ReactDOM.findDOMNode(wrapperRef);
        const top = wrapper.getBoundingClientRect().top;
        const height = 32 * menuItems.length;
        (top + height) >= 0 && (top + height) <= window.innerHeight ?
            setDirection('bottom-left') : setDirection('top-left');
    }, [menuItems, wrapperRef, props.direction]);


    return (
        <DropdownWrapper ref={r => wrapperRef = r}>
            {props.children}
            {props.display &&
            <DropdownInner
                offsetX={props.offsetX}
                offsetY={props.offsetY}
                direction={direction}
                width={props.width}
                maxHeight={props.maxHeight}
            >

                <DropdownList>
                    {menuItems.map((item, idx) => {
                        return (
                            <DropdownListItem
                                key={`${item.label}-${idx}`}
                                onClick={() => props.onChange(item)}
                            >

                                <DropdownListItemInner>{item.label}</DropdownListItemInner>
                            </DropdownListItem>
                        );
                    })
                    }
                </DropdownList>
            </DropdownInner>
            }
        </DropdownWrapper>
    );
};

export default DropdownMenu;
